import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {
            path: '/dashboard-financial',
            name: 'dashboard-financial',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')
            },
            component: () =>
                import('./DashboardFinancial/DashboardFinancial.vue')
        },
        {
            path: '/invoice-report',
            name: 'invoice-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')
            },
            component: () =>
                import('./InvoiceReport/InvoiceReport.vue')
        },
        {
            path: '/iugu-report',
            name: 'iugu-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                    if (isProjectPlan) next("/pages/login-horas")
                    else next('/pages/login')
                if(hasPermission) next()
                else next('/forbidden')
            },
            component: () =>
                import('./IuguReport/IuguReport.vue')
        },
        {
            path: '/account-information-and-balances',
            name: 'account-information-and-balances',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./AccountInformationAndBalances/AccountInformationAndBalances.vue')
        },
        {
            path: '/transfer-of-values',
            name: 'transfer-of-values',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./TransferOfValues/TransferOfValues.vue')
        },
        {
            path: '/conciliation-balance',
            name: 'conciliation-balance',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./ConciliationBalance/ConciliationBalance.vue')
        },
        {
            path: '/financial-statement-filoo',
            name: 'financial-statement-filoo',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./FinancialStatementFiloo/FinancialStatementFiloo.vue')
        },
        {
            path: '/transaction-report',
            name: 'transaction-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./TransactionReport/TransactionReport.vue')
        },
      {
        path: '/block-balance',
        name: 'block-balance',
        beforeEnter: (to, from, next) => {
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }

          if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
          else next()


        },
        component: () =>
          import('./BlockBalance/BlockBalance.vue')
      },
        {
            path: '/client-statement',
            name: 'client-statement',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./ClientsStatement/ClientsStatement.vue')
        },
        {
            path: '/professionals-statement',
            name: 'professionals-statement',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./ProfessionalsStatement/ProfessionalsStatement.vue')
        },
        {
            path: '/inactivated',
            name: 'Inactivated',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./Inactivated/Inactivated.vue')
        },
        {
            path: '/pf-customers-report',
            name: 'pf-customers-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./PFCustomersReport/PFCustomersReport.vue')
        },
        {
            path: '/withdraw-report',
            name: 'withdraw-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./WithdrawReport/WithdrawReport.vue')
        },
        {
            path: '/medical-records-report',
            name: 'medical-records-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./MedicalRecordsReport/MedicalRecordsReport.vue')
        },
        {
            path: '/pool-extract-report',
            name: 'pool-extract-report',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./PoolExtractReport/PoolExtractReport.vue')
        },
        {
            path: '/medical-appointments-performed-x-rps',
            name: 'medical-appointments-performed-x-rps',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
								Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()

            },
            component: () =>
                import('./MedicalAppointmentsPerformedXRPS/MedicalAppointmentsPerformedXRPS.vue')
        },
        {

            path: '/financial-parameterization-products-and-services',
            name: 'financial-parameterization-products-and-services',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path);
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./ProductAccessManagement/Services/Services.vue')
        },
        {

            path: '/financial-parameterization-messages',
            name: 'financial-parameterization-messages',
            beforeEnter: (to, from, next) => {
                const hasPermission = localStorage.getItem('systems').includes(to.path)
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }
                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                if (hasPermission) next()
                else next('/forbidden')

            },
            component: () =>
                import('./MessageDiffuser/MessageDiffuser/MessageDiffuser.vue')
        },
      {
        path: '/exposure-report',
        name: 'exposure-report',
        beforeEnter: (to, from, next) => {
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated) next('/pages/login')
          if (hasPermission) next()
          else next('/forbidden')

        },
        component: () =>
          import('../Financial/ExposureReport/ExposureReport.vue')
      },
      {
        path: '/tax-report',
        name: 'tax-report',
        beforeEnter: (to, from, next) => {
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated) next('/pages/login')
          if (hasPermission) next()
          else next('/forbidden')

        },
        component: () =>
          import('../Financial/TaxReport/TaxReport.vue')
      },
      {
        path: '/quicksight-financial-dashboard',
        name: 'quicksight-financial-dashboard',
        beforeEnter: (to, from, next) => {
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const bearer = Vue.prototype.$session.get("bearer");
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
            isAuthenticated = true;
          } else {
            isAuthenticated = false;
          }
          if (!isAuthenticated) next('/pages/login')
          if (hasPermission) next()
          else next('/forbidden')

        },
        component: () =>
            import('./QuicksightFinancial/QuicksightFinancial.vue')
    },
    {
      path: '/aas-sales-commission-report',
      name: 'aas-sales-commission-report',
      beforeEnter: (to, from, next) => {
        const hasPermission = localStorage.getItem('systems').includes(to.path);
        const bearer = Vue.prototype.$session.get("bearer");
        const bearerDefault = Vue.prototype.$session.get("bearerDefault");
        Vue.prototype.$session.set("bearer", bearerDefault);
        let isAuthenticated = false;
        if (bearer !== null && bearer !== undefined && bearer !== "") {
          isAuthenticated = true;
        } else {
          isAuthenticated = false;
        }
        if (!isAuthenticated) next('/pages/login')
        if (hasPermission) next()
        else next('/forbidden')

      },
      component: () =>
          import('./AasSalesCommissionReport/AasSalesCommissionReport.vue')
  },
  {
    path: '/commissioning-by-subscription',
    name: 'commissioning-by-subscription',
      beforeEnter: (to, from, next) => {
        
          const bearer = Vue.prototype.$session.get("bearer");
          const hasPermission = localStorage.getItem('systems').includes(to.path);
          const bearerDefault = Vue.prototype.$session.get("bearerDefault");
          const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
          Vue.prototype.$session.set("bearer", bearerDefault);
          let isAuthenticated = false;
          if (bearer !== null && bearer !== undefined && bearer !== "") {
              isAuthenticated = true;
          } else {
              isAuthenticated = false;
          }
          if (!isAuthenticated)
              if (isProjectPlan) next("/pages/login-horas")
              else next('/pages/login')
          if(hasPermission) next()
          else next('/forbidden')
      },
    component: () =>
        import('./CommissioningBySubscription/CommissioningBySubscription.vue')
},
    ]
}
export default [
    routes
]

